module.exports = __webpack_public_path__ + "static/media/alert.e10d3ff8.svg";